// A deploy replaces JS chunk files with new content hashes. A tab that's had
// the app open since before the deploy still holds a bundle referencing an
// old hash, so fetching that chunk 404s — via a dynamic import() during a
// client-side route navigation (see RouteErrorBoundary), or via a
// <link rel="modulepreload"> (see main.tsx's `vite:preloadError` listener).
// A full reload re-fetches index.html and the current hashes, fixing it.
const RELOAD_ATTEMPTED_KEY = 'app_chunk_reload_attempted';

// Reload at most once per tab session so a genuinely broken deploy (chunk
// still missing after a fresh reload) shows a real error instead of looping.
export const reloadOnceForStaleChunk = (): void => {
  if (sessionStorage.getItem(RELOAD_ATTEMPTED_KEY)) return;
  sessionStorage.setItem(RELOAD_ATTEMPTED_KEY, '1');
  window.location.reload();
};
